module.exports = __webpack_public_path__ + "img/error_old.ff3d6be6.png";